import { render, staticRenderFns } from "./dat-new.vue?vue&type=template&id=32839d1a&"
import script from "./dat-new.vue?vue&type=script&lang=js&"
export * from "./dat-new.vue?vue&type=script&lang=js&"
import style0 from "./dat-new.vue?vue&type=style&index=0&lang=css&"
import style1 from "./dat-new.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports